import UnitSummaryDetails from './UnitSummaryDetails';

export default UnitSummaryDetails;
